export const CELEBRATION_EVENT = 'caravan:celebrate'
export type CelebrationKind = 'opening' | 'photo' | 'challenge' | 'vote' | 'like' | 'reveal' | 'day_complete'

let pendingCelebrations: CelebrationKind[] = []

export function triggerCelebration(kind: CelebrationKind): void {
  const handled = !window.dispatchEvent(new CustomEvent<CelebrationKind>(CELEBRATION_EVENT, {
    cancelable: true,
    detail: kind,
  }))
  if (!handled) pendingCelebrations.push(kind)
}

export function takePendingCelebration(): CelebrationKind | null {
  const next = pendingCelebrations.at(-1) ?? null
  pendingCelebrations = []
  return next
}
